export default "__VITE_ASSET__Cv1nWBMu__"